import { render, staticRenderFns } from "./LaboratorySideBar.vue?vue&type=template&id=704979f4&scoped=true&"
import script from "./LaboratorySideBar.vue?vue&type=script&lang=js&"
export * from "./LaboratorySideBar.vue?vue&type=script&lang=js&"
import style0 from "./LaboratorySideBar.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./LaboratorySideBar.vue?vue&type=style&index=1&id=704979f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704979f4",
  null
  
)

export default component.exports